import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import md5 from "blueimp-md5";
import { useVuelidate } from "@vuelidate/core";
import { email, required, requiredIf } from "@vuelidate/validators";
import { mapActions, mapState } from "pinia";
import BaseBtModal from "../BaseBtModal.vue";
//@ts-ignore
import BaseTextarea from "@vueEntry/UIKitComponents/BaseTextarea.vue";
//@ts-ignore
import BaseCheckbox from "../UIKitComponents/Checkbox/CheckboxBtn.vue";
import CustodianSupervisorCard from "@vueEntry/CustodianSupervisorCard.vue";
//@ts-ignore
import { useKeyEnterPressed } from "@wkComposables/useKeyEnterPressed";
import { getPhoneLabelElements, hasGaEventSent, showPhoneLabel, useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { getAgencyById } from "@services/agencyAPI";
//@ts-ignore
import { SubscriptionType } from "@customTypes/SubscriptionType";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import CardSlider from "@vueEntry/CardSlider.vue";
//@ts-ignore
import { useValidator } from "@wkComposables/useValidator";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
//@ts-ignore
import { replaceAllTokens } from "@utils/StringUtils";
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
import { defineAsyncComponent, defineComponent } from "vue";
import { useModalStore } from "@store/ModalStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
import { sendConsultantRequestContact, sendMultipleConsultantRequestContact } from "@services/AuctionAPI";
import { useLoggedUserStore, useMetadataStore } from "@wkWebSrc/js/store";
//@ts-ignore
import { getOrNull } from "@utils/ObjectUtils";
var requiredIfNotLogged = {
  required: requiredIf(function () {
    return !this.isUserLogged;
  })
};
export default defineComponent({
  name: "ContactAgencyModal",
  components: {
    BaseInput,
    BaseButton,
    BaseAlert,
    BaseBtModal,
    BaseCheckbox,
    BaseTextarea,
    CardSlider,
    PhoneIcon,
    CustodianSupervisorCard,
    "contact-agency-success": defineAsyncComponent(() => import("./ContactAgencySuccess.vue")),
    "limit-modal": defineAsyncComponent(() => import("./Status/LimitModal.vue")),
    "limit-saved-modal": defineAsyncComponent(() => import("./Status/LimitSavedModal.vue")),
    "unauthorized-modal": defineAsyncComponent(() => import("./Status/UnauthorizedModal.vue")),
    "generic-success-modal": defineAsyncComponent(() => import("./GenericSuccessModal.vue"))
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object
    },
    labels: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: "realEstate"
    },
    showAgencyBanner: {
      type: Boolean,
      default: false
    },
    reopenAfterLogin: {
      type: Boolean,
      default: false
    },
    valueTextarea: {
      type: String,
      default: ""
    },
    isAuction: {
      type: Boolean,
      default: false
    },
    consultantsList: {
      type: Object,
      required: false,
      default: Object
    },
    endedAuction: {
      type: Boolean,
      required: false,
      default: false
    },
    auctionSupervisor: {
      type: Object,
      required: false
    },
    // TODO: non è bello avere una proprietà publicUser in un componente per l'agency
    advertisingPublicUserID: {
      type: Number,
      required: false
    },
    publicUserName: {
      type: String,
      required: false
    }
  },
  emits: ["update:modelValue", "switch-off-reopen", "closed-modal", "show-valuation-modal", "open-login-modal"],
  setup() {
    var {
      enterPressedCb,
      onEnterPressed
    } = useKeyEnterPressed();
    var {
      isDesktopMode
    } = useBreakpoints();
    var {
      displayPhone,
      phoneLabel,
      showPhone
    } = useShowPhone();
    var {
      isValid
    } = useValidator();
    return {
      v$: useVuelidate(),
      enterPressedCb,
      onEnterPressed,
      isDesktopMode,
      displayPhone,
      phoneLabel,
      showPhone,
      isValid
    };
  },
  data() {
    return {
      errorMessage: "",
      userInteraction: false,
      agencyData: null,
      agencyModalData: {},
      agencyLogo: null,
      requestData: {
        name: "",
        //TODO: il campo surname andrà eliminata se non si cambia idea, se fra un mese leggi questo commento eliminalo pure!
        /*  surname: "",*/
        email: "",
        phone: "",
        message: "",
        privacy: true,
        marketing: false
        //TODO: da riattivare qunado si avrà la privacy policy delle agenzie
        // third_party_privacy: false
      },
      successModalData: null,
      successModalConfig: null,
      show: false,
      success: null,
      loginSuccess: false,
      /** If true, then we faced a duplication error, otherwise (if the value is false) this variable will indicate a generic error */
      duplicateErrorRequest: null,
      /** The -1 value stands for the default value */
      errorCode: -1,
      isSubmitting: false,
      showContactSuccessModal: false,
      showMessageSentSuccess: false,
      isPrestigious: null,
      isMultipleConsultantRequest: false,
      haveExtraOrTopConsultant: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    isPremium() {
      var _a;
      return !!((_a = this.modelValue) === null || _a === void 0 ? void 0 : _a.premium);
    },
    byClicking() {
      return "".concat(this.tokenizedPrivacyPolicy[0]);
    },
    tokenizedPrivacyPolicy() {
      return this.labels.read_and_accepted_by_clicking_2.split(/\{[^{}]*\}|\d+/);
    },
    IDeclareToHaveReadAndAccepted() {
      return ", dichiaro di aver preso visione dell'";
      // return `${this.tokenizedPrivacyPolicy[1]}`;
    },
    wikicasaPrivacyPolicyText() {
      return "".concat(this.labels.privacy_policy, " (").concat(this.labels.purpose, " C)");
    },
    of_1() {
      return "".concat(this.tokenizedPrivacyPolicy[2]);
    },
    of_2() {
      return "".concat(this.tokenizedPrivacyPolicy[3]);
    },
    privacy_C_section() {
      return "".concat(this.labels.purpose, " C");
    },
    privacy_D_section() {
      return "".concat(this.labels.purpose, " D");
    },
    readAndAcceptedByClicking() {
      var placeholder = "{0}";
      var tokens = this.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold\">").concat(replaceAllTokens(placeholder, {
        "{0}": this.endedAuction ? this.labels.send : this.labels.requestInfos
      }), "</span>").concat(tokens[1]);
    },
    SUBSCRIPTION_TYPE() {
      return SubscriptionType;
    },
    baseUrl() {
      return window["_baseURL"];
    },
    lang() {
      return window["_lang"];
    },
    eventLocation() {
      return "".concat(this.pageName, " - ").concat(this.location);
    },
    isMobile() {
      return window.innerWidth <= 575;
    }
  }, mapState(usePublicUserMenuStore, {
    pumMarketing: "marketing",
    publicUserId: "publicUserId"
  })), mapState(useMetadataStore, ["pageName", "location"])), mapState(usePublicUserMenuStore, ["email", "name"])), mapState(useLoggedUserStore, ["isUserLogged"])),
  watch: {
    userInteraction(cur) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
      if (!cur) return;
      if (this.modelValue && this.isAuction) sendGAEvent("auction_consultant_request_interaction", {
        event_location: this.eventLocation,
        auction_consultant_id: (_a = this.modelValue) === null || _a === void 0 ? void 0 : _a.agencyId,
        auction_consultant_name: getOrNull((_b = this.modelValue) === null || _b === void 0 ? void 0 : _b.agencyName),
        real_estate_id: getOrNull((_c = this.modelValue) === null || _c === void 0 ? void 0 : _c.id),
        real_estate_place_id: getOrNull((_d = this.modelValue) === null || _d === void 0 ? void 0 : _d.placeID),
        real_estate_contract_type: "auction"
      });else sendGAEvent("specific_request_interaction", {
        event_location: this.eventLocation,
        agency_id: this.agencyModalData.agencyId,
        agency_name: getOrNull((_e = this.agencyData) === null || _e === void 0 ? void 0 : _e.name),
        agency_subscription_type: this.agencyModalData.premium ? "premium" : this.agencyModalData.lite ? "lite" : "free",
        agent_email: this.agencyModalData.agentEmail ? md5(this.agencyModalData.agentEmail) : null,
        agent_id: getOrNull(this.agencyModalData.agentId),
        agency_franchise_id: getOrNull(this.agencyModalData.franchiseId),
        agency_franchise_name: getOrNull(this.agencyModalData.franchiseName),
        product_id: ((_f = this.modelValue) === null || _f === void 0 ? void 0 : _f.id) ? "WK_".concat(this.modelValue.id) : null,
        product_price: this.agencyModalData.id ? parseFloat("".concat(this.agencyModalData.price).replace(".", "")) : null,
        real_estate_contract_type: ((_g = this.modelValue) === null || _g === void 0 ? void 0 : _g.rent) ? "rent" : "sale",
        real_estate_id: getOrNull((_h = this.modelValue) === null || _h === void 0 ? void 0 : _h.id),
        real_estate_place_id: getOrNull((_j = this.modelValue) === null || _j === void 0 ? void 0 : _j.placeID),
        real_estate_price: getOrNull((_k = this.modelValue) === null || _k === void 0 ? void 0 : _k.price),
        real_estate_typology_name: getOrNull((_l = this.modelValue) === null || _l === void 0 ? void 0 : _l.typologyName),
        user_id: this.publicUserId == -1 ? null : this.publicUserId,
        user_email_hashed: md5(this.requestData.email || this.email),
        user_email: this.requestData.email || this.email,
        user_name: this.isUserLogged ? this.name : this.requestData.name,
        user_phone: getOrNull(this.requestData.phone),
        agency_place_id: null
      });
    }
  },
  validations() {
    return {
      requestData: {
        name: Object.assign({}, requiredIfNotLogged),
        /* surname: {},*/
        email: Object.assign(Object.assign({}, requiredIfNotLogged), {
          email
        }),
        phone: {},
        message: {
          required
        },
        marketing: {}
        //TODO: da riattivare quando si avrà la privacy policy delle agenzie
        // third_party_privacy: {}
      }
    };
  },
  created() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
      this.setLocation("Modale contatta agenzia (step 1)");
      if (this.modelValue && this.isAuction) {
        sendGAEvent("auction_consultant_request_open_form", {
          event_location: this.eventLocation,
          auction_consultant_id: (_a = this.modelValue) === null || _a === void 0 ? void 0 : _a.agencyId,
          auction_consultant_name: getOrNull((_b = this.modelValue) === null || _b === void 0 ? void 0 : _b.agencyName),
          real_estate_place_id: getOrNull((_c = this.modelValue) === null || _c === void 0 ? void 0 : _c.placeID),
          real_estate_id: getOrNull((_d = this.modelValue) === null || _d === void 0 ? void 0 : _d.id),
          real_estate_contract_type: "auction"
        });
      }
      if (this.reopenAfterLogin) {
        this.success = true;
        this.errorCode = -1;
        this.successModalConfig = {
          showSaveSearch: true,
          showGenericRequest: true
        };
        this.successModalData = this.modelValue;
      }
      if (this.modelValue) {
        this.agencyModalData = this.modelValue;
        if (this.isAuction && this.consultantsList.length > 1 && !(this.consultantsList[0].extra_flag || this.consultantsList[0].top_flag) && this.isMobile) this.isMultipleConsultantRequest = true;
      } else {
        var storedData = localStorage.getItem("modalPayload");
        if (!storedData) return;
        this.agencyModalData = JSON.parse(storedData);
        this.$emit("update:modelValue", this.agencyModalData);
      }
      this.onEnterPressed(this.submitForm);
      /* Used by ShowPhoneMixin.ts */
      //@ts-ignore
      this.phoneLabel = this.labels.phone;
      //@ts-ignore
      yield this.getAgencyAsync();
      var {
        agencyId
      } = this.agencyModalData;
      if (hasGaEventSent(agencyId))
        //@ts-ignore
        showPhoneLabel(getPhoneLabelElements(agencyId), this.displayPhone);
    });
  },
  mounted() {
    this.requestData.message = !this.isAuction ? this.valueTextarea : "Ho visto questo annuncio all’asta su Wikicasa e vorrei maggiori informazioni";
    this.show = this.showModal;
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    redirectToAgencyDetails(url) {
      var isAgencyPremium = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!isAgencyPremium) return;
      window.location.href = url;
    },
    switchOffReopen() {
      this.$emit("switch-off-reopen");
    },
    openLoginModal() {
      this.show = false;
      this.$emit("open-login-modal");
    },
    openSigninModal() {
      this.show = false;
      //@ts-ignore
      this.setShowModal("SIGNIN_MODAL");
    },
    openPrivacyDisclaimer() {
      window.open("/privacy", "_blank", "scrollbars=yes, width=550, height=600");
    },
    handleShowErrorModal(errorCode) {
      this.errorCode = errorCode;
    },
    handleSendAgencyContact() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
      return __awaiter(this, void 0, void 0, function* () {
        this.requestData.marketing = this.requestData.marketing || this.pumMarketing;
        var contactsData = {
          agentId: this.agencyModalData.agentId,
          referenceId: this.agencyModalData.id || -1,
          canonicalURL: this.agencyModalData.canonicalURL,
          notes: this.requestData.message,
          marketingConsent: this.requestData.marketing
        };
        if (this.agencyModalData.agencyId == this.advertisingPublicUserID) contactsData["advertisingPublicUserId"] = this.advertisingPublicUserID;else contactsData["agencyId"] = this.agencyModalData.agencyId;
        if (!this.isUserLogged) {
          contactsData.name = "".concat(this.requestData.name);
          contactsData.email = this.requestData.email;
          contactsData.phone = this.requestData.phone;
        }
        var res = this.isAuction && !this.endedAuction ? yield sendConsultantRequestContact(contactsData) : yield this.sendAgencyContact(contactsData);
        if (!res) return;
        this.isUserLogged && this.setMarketing(this.requestData.marketing);
        var price = null;
        var agencyWithId = !!this.agencyModalData.id;
        if (agencyWithId) price = parseFloat("".concat(this.agencyModalData.price).replace(".", ""));
        var {
          agencyModalData: data
        } = this;
        // TODO: check dell'auction_consultant_lead corretto in caso di asta conclusa
        if (this.isAuction) sendGAEvent("auction_consultant_lead", {
          event_location: this.endedAuction ? "".concat(this.eventLocation, " - Modale asta scaduta") : this.eventLocation,
          auction_consultant_id: data === null || data === void 0 ? void 0 : data.agencyId,
          auction_consultant_name: getOrNull((_a = this.agencyData) === null || _a === void 0 ? void 0 : _a.name),
          real_estate_id: getOrNull(data === null || data === void 0 ? void 0 : data.id),
          real_estate_contract_type: "auction",
          real_estate_place_id: getOrNull((_b = this.modelValue) === null || _b === void 0 ? void 0 : _b.placeID),
          user_id: this.publicUserId == -1 ? null : this.publicUserId,
          contract_type: "auction",
          user_email_hashed: md5(this.requestData.email || this.email),
          user_email: this.requestData.email || this.email
        });else {
          if (!this.advertisingPublicUserID) sendGAEvent("specific_request_lead", {
            event_location: this.eventLocation,
            agency_id: this.agencyModalData.agencyId,
            agency_name: getOrNull((_c = this.agencyData) === null || _c === void 0 ? void 0 : _c.name),
            agency_place_id: null,
            agency_subscription_type: this.agencyModalData.premium ? "premium" : this.agencyModalData.lite ? "lite" : "free",
            agent_email: data.agentEmail ? md5(data.agentEmail) : null,
            agent_id: getOrNull(this.agencyModalData.agentId),
            agency_franchise_id: getOrNull(this.agencyModalData.franchiseId),
            agency_franchise_name: getOrNull(this.agencyModalData.franchiseName),
            product_id: ((_d = this.modelValue) === null || _d === void 0 ? void 0 : _d.id) ? "WK_".concat(this.modelValue.id) : null,
            product_price: data.id ? price : null,
            real_estate_contract_type: ((_e = this.modelValue) === null || _e === void 0 ? void 0 : _e.rent) ? "rent" : "sale",
            real_estate_id: getOrNull((_f = this.modelValue) === null || _f === void 0 ? void 0 : _f.id),
            real_estate_place_id: getOrNull((_g = this.modelValue) === null || _g === void 0 ? void 0 : _g.placeID),
            real_estate_price: getOrNull((_h = this.modelValue) === null || _h === void 0 ? void 0 : _h.price),
            real_estate_typology_name: getOrNull((_j = this.modelValue) === null || _j === void 0 ? void 0 : _j.typologyName),
            user_email_hashed: md5(this.requestData.email || this.email),
            user_email: this.requestData.email || this.email,
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            user_name: this.isUserLogged ? this.name : this.requestData.name,
            user_phone: this.requestData.phone
          });else sendGAEvent("specific_request_lead", {
            event_location: this.eventLocation,
            advertisingPublicUserID: this.advertisingPublicUserID,
            agency_name: null,
            agency_place_id: null,
            agency_subscription_type: "free",
            agent_email: null,
            agent_id: null,
            agency_franchise_id: null,
            agency_franchise_name: null,
            product_id: ((_k = this.modelValue) === null || _k === void 0 ? void 0 : _k.id) ? "WK_".concat(this.modelValue.id) : null,
            product_price: data.id ? price : null,
            real_estate_contract_type: ((_l = this.modelValue) === null || _l === void 0 ? void 0 : _l.rent) ? "rent" : "sale",
            real_estate_id: getOrNull((_m = this.modelValue) === null || _m === void 0 ? void 0 : _m.id),
            real_estate_place_id: getOrNull((_o = this.modelValue) === null || _o === void 0 ? void 0 : _o.placeID),
            real_estate_price: getOrNull((_p = this.modelValue) === null || _p === void 0 ? void 0 : _p.price),
            real_estate_typology_name: getOrNull((_q = this.modelValue) === null || _q === void 0 ? void 0 : _q.typologyName),
            user_email_hashed: md5(this.requestData.email || this.email),
            user_email: this.requestData.email || this.email,
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            user_name: this.isUserLogged ? this.name : this.requestData.name,
            user_phone: this.requestData.phone
          });
        }
        var modalConfig = {
          showSaveSearch: true,
          showGenericRequest: true
        };
        this.successModalData = Object.assign(Object.assign({}, data), contactsData);
        this.successModalConfig = modalConfig;
        this.showContactSuccessModal = true;
        //Opening the success modal! // TODO: deprecate?
        this.success = true;
      });
    },
    handleSendMultipleConsultantContact() {
      return __awaiter(this, void 0, void 0, function* () {
        var contactsData = {};
        var contactsDataArray = [];
        this.requestData.marketing = this.requestData.marketing || this.pumMarketing;
        if (!this.isUserLogged) {
          contactsData.name = "".concat(this.requestData.name);
          contactsData.email = this.requestData.email;
          contactsData.phone = this.requestData.phone;
        }
        this.consultantsList.forEach(consultant => {
          var _a;
          contactsData.agencyId = consultant.consultant_agency.id;
          contactsData.referenceId = this.agencyModalData.id || -1;
          contactsData.canonicalURL = window["_canonicalURL"];
          contactsData.notes = this.requestData.message;
          contactsData.marketingConsent = this.requestData.marketing;
          contactsDataArray.push(Object.assign({}, contactsData));
          var {
            agencyModalData: data
          } = this;
          sendGAEvent("auction_consultant_lead", {
            event_location: this.eventLocation,
            auction_consultant_id: consultant.consultant_agency.id,
            auction_consultant_name: getOrNull(consultant.consultant_agency.name),
            real_estate_id: getOrNull(data === null || data === void 0 ? void 0 : data.id),
            real_estate_contract_type: "auction",
            real_estate_place_id: getOrNull((_a = this.modelValue) === null || _a === void 0 ? void 0 : _a.placeID),
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            contract_type: "auction",
            user_email_hashed: md5(this.requestData.email || this.email),
            user_email: this.requestData.email || this.email
          });
        });
        this.isUserLogged && this.setMarketing(this.requestData.marketing);
        var res = sendMultipleConsultantRequestContact(contactsDataArray);
        if (!res) return;
        this.showMessageSentSuccess = true;
      });
    },
    submitForm() {
      return __awaiter(this, void 0, void 0, function* () {
        if (this.duplicateErrorRequest || this.isSubmitting) return false;
        this.v$.$touch(); //Touching all fields!
        if (this.v$.$invalid) return false;
        this.isSubmitting = true;
        var result = true;
        try {
          if (!this.isMultipleConsultantRequest) yield this.handleSendAgencyContact();else yield this.handleSendMultipleConsultantContact();
        } catch (err) {
          var {
            response
          } = err;
          if (response.status === 409) {
            sendGAEvent("specific_request_error_409", {
              event_location: this.eventLocation
            });
            this.errorMessage = this.labels.requestErrorDuplicatedLabel;
            this.duplicateErrorRequest = true;
          } else if (response.state !== 409) this.errorMessage = this.labels.requestErrorLabel;
          result = false;
        } finally {
          this.isSubmitting = false;
        }
        return result;
      });
    },
    getAgencyAsync() {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        try {
          var data = yield getAgencyById(this.agencyModalData.agencyId, this.lang);
          this.agencyData = {
            //@ts-ignore
            url: "".concat(this.baseUrl).concat(data.url),
            name: data.name,
            address: "".concat(data.address, ", ").concat((_a = data.zip) !== null && _a !== void 0 ? _a : "", " ").concat(data.cityName),
            logo: "/rest/agency/getAgencyImageByAgencyID/".concat(data.id, "/2"),
            displayPhone: data.displayPhone
          };
          this.isPrestigious = data.prestigious;
          this.agencyModalData.agencyName = this.agencyData.name;
          /* Used by the showPhoneMixin */
          //@ts-ignore
          this.displayPhone = this.agencyData.displayPhone;
        } catch (err) {
          //some error code
        }
      });
    },
    closedModal() {
      if (this.showMessageSentSuccess) {
        setTimeout(() => {
          this.$emit("closed-modal");
        }, 1000);
      } else this.$emit("closed-modal");
    },
    showValuationModal() {
      this.$emit("show-valuation-modal");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useMetadataStore, ["setLocation"])), mapActions(usePublicUserMenuStore, ["setMarketing", "sendAgencyContact", "sendConsultantAuctionContact"])), mapActions(useMetadataStore, ["setLocation"]))
});